<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login-page">
    <header class="login-header">
      <div class="brand" @click="goLanding">
        <div class="brand-mark">H</div>
        <div class="brand-text">
          <strong>纳思 HawkSense</strong>
          <span>AI 验布平台</span>
        </div>
      </div>
      <button class="back-home-btn" type="button" @click="goLanding">
        返回首页
      </button>
    </header>

    <section class="login-body">
      <div class="login-intro">
        <article class="intro-main-card">
          <p class="intro-kicker">SMART TEXTILE INSPECTION</p>
          <h1>登录 HawkSense，开启智能验布管理</h1>
          <p class="intro-subtitle">
            统一查看设备状态、缺陷识别结果与运行效益，让 AI 验布真正落地。
          </p>
        </article>

        <div class="intro-metric-grid">
          <article
            v-for="item in introCards"
            :key="item.title"
            class="intro-metric-card"
          >
            <p class="metric-value">{{ item.value }}</p>
            <h3>{{ item.title }}</h3>
            <p class="metric-desc">{{ item.desc }}</p>
          </article>
        </div>
      </div>

      <div class="login-panel">
        <Card :bordered="false">
          <div class="card-title-wrap">
            <h2>欢迎登录</h2>
            <p>请输入账号和密码访问管理后台</p>
          </div>
          <div class="form-con">
            <login-form @on-success-valid="handleSubmit"></login-form>
            <p class="login-tip">忘记密码请联系管理员</p>
          </div>
        </Card>
      </div>
    </section>

    <div class="login-bg-glow login-bg-glow-1"></div>
    <div class="login-bg-glow login-bg-glow-2"></div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'

export default {
  components: {
    LoginForm
  },
  data () {
    return {
      introCards: [
        {
          value: '90%+',
          title: '缺陷检出率',
          desc: 'AI 模型高精度识别，减少漏检误检。'
        },
        {
          value: '50-120m/min',
          title: '验布速度',
          desc: '显著高于传统人工，效率稳定可控。'
        },
        {
          value: 'OTA',
          title: '在线升级',
          desc: '算法持续迭代，设备能力不断增强。'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ username, password }) {
      this.handleLogin({ username, password }).then(res => {
        this.getUserInfo().then(res => {
          const userAccess = this.$store.state.user.access
          const defaultHome = this.getDefaultHomeByAccess(userAccess)
          this.$router.push({
            name: defaultHome
          })
        })
      })
    },
    goLanding () {
      this.$router.push({ name: 'landing' })
    },
    getDefaultHomeByAccess (access) {
      if (access.includes('admin') || access.includes('Operation Management')) {
        return 'home'
      } else if (access.includes('customer')) {
        return 'server_list'
      } else {
        return 'home'
      }
    }
  }
}
</script>
